// removed by extract-text-webpack-plugin
module.exports = {"main":"HorizontalSection-main--1zOiV","center":"HorizontalSection-center--3fcb2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DataPanel/HorizontalSection/HorizontalSection.scss
// module id = eq+V
// module chunks = 4